import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "影视库", href: "#catalog" },
  { label: "剧集热播", href: "#series" },
  { label: "口碑榜", href: "#top-rated" },
  { label: "按类型", href: "#genres" },
  { label: "观影指南", href: "#guide" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "border-b border-background-200 bg-background-50/95 backdrop-blur" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              solid ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-heading text-lg font-bold ${solid ? "text-foreground-950" : "text-background-50"}`}>
              星辰影院
            </span>
            <span className={`text-[11px] tracking-wide ${solid ? "text-foreground-500" : "text-background-200"}`}>
              STAR CINEMA
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
                  : "text-background-100 hover:bg-background-50/10 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#catalog"
            className="ml-2 flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-circle-line"></i>
            立即观看
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            solid ? "text-foreground-950 hover:bg-secondary-100" : "text-background-50 hover:bg-background-50/10"
          }`}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#catalog"
              onClick={() => setMenuOpen(false)}
              className="mt-2 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-play-circle-line"></i>
              立即观看
            </a>
          </div>
        </div>
      )}
    </header>
  );
}